export enum ChangeStatusType {
    Added = 0,
    Deleted = 1,
    Updated = 2,
}
